import { createContext } from 'react';

export interface FullscreenContextType {
  isFullscreen: boolean;
  toggleFullscreen: () => void;
  setFullscreen: (value: boolean) => void;
}

const FullscreenContext = createContext<FullscreenContextType>({
  isFullscreen: false,
  toggleFullscreen: () => {
    /* */
  },
  setFullscreen: () => {
    /* */
  },
});

export default FullscreenContext;
